export class AuthModel {
  authToken: string;
  refreshToken: string;
  expiresIn: Date;

  setAuth(auth: AuthModel) {
    this.authToken = auth.authToken;
    this.refreshToken = auth.refreshToken;
    this.expiresIn = auth.expiresIn;
  }

  setAuthFromParam(authToken: string, refreshToken: string, expiresIn: string) {
    this.authToken = authToken;
    this.refreshToken = refreshToken;
    this.expiresIn = new Date(expiresIn);
  }
}
